import React from 'react';
import AmplitudeHelperClass from '/src/lib/amplitudeHelper';
import { PUBLIC_IMG_URL } from '../../../src/lib/endpoints'
import { HUBSPOT_FORM_SOURCE, DEAL_TERM_MEANING, INVESTMENT_VEHICLE_MEANING, HOME_DASHBOARD_SECTION_MESSAGES } from '/src/lib/constants';
import { VerificationPillBadgeToolTip } from '../SingleSICE/Reusable/Helpers/sice-profile-helpers';
import SocialTab from '../SingleSICE/Reusable/SocialTab';
import { getTableTitle, getVerificationIcon } from '../SingleSICE/Reusable/FundingRounds/Helpers/fundingViewHelpers';
import DynamicStartupBenchmarking from '../SingleSICE/Reusable/DynamicStartupBenchmarking';
import LockedInvestorInvestmentsSection from '/src/components/LockedContent/Components/LockedInvestorInvestmentsSection';
import LockedFundsInvestedSection from '/src/components/LockedContent/Components/LockedFundsInvestedSection';
import LockedPortfolioExitsSection from '/src/components/LockedContent/Components/LockedPortfolioExitsSection';
import LockedFundingRoundsSection from '/src/components/LockedContent/Components/LockedFundingRoundsSection';
import LockedTeamMembersSection from '/src/components/LockedContent/Components/LockedTeamMembersSection';
import { withBootstrapPlugin } from '/src/lib/helpers';

const amplitudeHelper = new AmplitudeHelperClass();
const nl2br = require('react-nl2br');

// prepare sample data/rows for sections on the site that are locked behind a paywall
// multiple test values so it isn't obvious that the rows are duplicated

const testCompany = ["R2-D2's Repairs", "Mandalorian Armor", "Maul's Payments", "Solo Adventures", "C3P0 Translations", "Jar Jar Inks", "Skywalker Enterprises", "Death Star Inc.", "Wookiee Repairs", "Ewok Adventures"];
const testDescription = [
    "R2-D2’s Repairs is a company specializing in astromech droid maintenance and technical assistance. With a spunky and adventurous attitude, they’ve saved the galaxy countless times by keeping droids like R2-D2 in top shape.",
    "Mandalorian Armor is a company that specializes in crafting and providing iconic armor inspired by the warrior culture of the planet Mandalore in the Star Wars™ Universe",
    "From digital wallets to contactless payments, Maul’s Payments keeps the gears turning and the funds flowing",
    "Solo Adventures is a company that specializes in creating small group guided tours specifically designed for solo travelers",
    " From diplomatic negotiations to deciphering ancient Sith texts, C3P0 Translations bridges linguistic gaps with precision and a touch of droid charm!"
]
const testInvestor = ["The Jedi Foundation", "Wookie Ventures", "Death Star Enterprises", "Padawan Ventures", "Skywalker Partners", "Sith Venture Capital (SVC)", "Rebel Alliance Fund"];
const testIndustries = ["Space Exploration", "Robot Repairs", "Robotics Manufacturing", "Space Tours", "Vending Solutions"];
const testPeople = ["John", "Jane", "Angela", "Valerie", "Botir", "Doe"];
const testStage = ["Launch", "SEED", "Growth", "Maturity", "Acquired"];
const roundVerified = [0, 1];
const testAmount = ["$100M", "$250.0K"];
const testDate = ["Jan 2021", "Dec 2020"];
const mockDate = ["2020-01-01", "2020-02-02", "2020-03-03", "2020-04-04"];
const testLocation = ["UAE", "KSA", "Bahrain", "Kuwait", "Oman", "Qatar"];
const testNumber = [101, 202, 303, 404, 505, 606, 707, 808, 909, 1010];
const testWebsite = ["https://www.mocksite.com", "https://www.mocksite2.com", "https://www.mocksite5.com", "https://www.mocksite6.com"];
const testNameCode = ["R2D2", "Mandalorian", "Maul", "Solo", "C3P0", "JarJar"];
const lockImg = <i className="fas fa-lock"></i>

const mainLogo = `${PUBLIC_IMG_URL}/main_logo.png`

// helper functions

function getRandom(list) {
    return list[Math.floor((Math.random() * list.length))];
}

function Login(event) {
    if (typeof window !== 'undefined') {
        const headerLogin = document.getElementById('headerLogin');
        if (headerLogin) {
            headerLogin.click();
        }
    }
}

function amplitudeTrack(action) {
    amplitudeHelper.trackEvent(action);
}

function generateArrayOfObjects(templateObject, arrayLength = 4) {
    const newArray = []
    for (let i = 0; i < arrayLength; i++) {
        newArray.push(templateObject)
    }
    return newArray
}

// function for displaying the contact sales popup form
function showContactForm(setState, directoryPage) {

    if (directoryPage) {
        setState({ contactSalesPopUpSource: HUBSPOT_FORM_SOURCE.startups_dir_locked_section })
    } else {
        setState({ contactSalesPopUpSource: HUBSPOT_FORM_SOURCE.single_profile_locked_sections })
    }

    withBootstrapPlugin('modal', ($) => $('#contactFormModal').modal({
        backdrop: 'static', keyboard: true, show: true
    }));
}

//get tempData outside of exported functions to avoid re-rendering on every render
const tempCompany = getRandom(testCompany);
const tempIndustry = getRandom(testIndustries);
const tempDescription = getRandom(testInvestor);
const tempPeople = getRandom(testPeople);

const getLockedFundingMessage = (entityType, sectionType = '') => {
    if (sectionType === 'portfolioExits') {
        return `Upgrade your MAGNiTT account to view all Portfolio Exits for this ${entityType}`;
    }

    if (sectionType === 'investorInvestments') {
        return `Upgrade your MAGNiTT account to view all Investments for this ${entityType}`;
    }

    if (sectionType === 'investmentsInFunds') {
        return `Upgrade your MAGNiTT account to view all Funds Invested In for this ${entityType}`;
    }

    return `Upgrade your MAGNiTT account to view all funding rounds and investment data for this ${entityType}`;
};

// exported functions
export const renderLockedFundingRoundsHeader = (entityType, sectionType = '') => {
    return (
        <div className="paywall-box">
            <div className="paywall-content">
                <a href='/pricing' onClick={() => amplitudeTrack('Pricing ' + entityType.charAt(0).toUpperCase() + entityType.slice(1) + ' - Funding Information')}>
                    <span className="paywall-label">
                        <div className="locked-inline-section">
                            <div className="m-0">
                                <div className="paywall-label-header">
                                    Preview of a locked feature
                                </div>
                                <div className="paywall-label-message">
                                    {getLockedFundingMessage(entityType, sectionType)}
                                </div>
                            </div>
                            <span className="btn btn-main locked-inline-button">Learn More</span>
                        </div>
                    </span>
                </a>
            </div>
        </div>
    )
}

export const renderLockedInvestorInvestmentsSection = () => (
    <LockedInvestorInvestmentsSection />
);

export const renderLockedFundsInvestedSection = () => (
    <LockedFundsInvestedSection />
);

export const renderLockedPortfolioExitsSection = () => (
    <LockedPortfolioExitsSection />
);

export const renderLockedFundingRoundsSection = () => (
    <LockedFundingRoundsSection />
);

export const renderLockedFundingRounds = (notShowStartup, notOwner, showVerified) => {

    let repeatRows = [];
    let rowsToDisplay = 3;

    for (let i = 0; i < rowsToDisplay; i++) {

        const tempCompany = getRandom(testCompany);
        const tempStage = getRandom(testStage);
        const tempInvestor = getRandom(testInvestor);
        const tempVerified = getRandom(roundVerified);
        const tempAmount = getRandom(testAmount);
        const tempDate = getRandom(testDate);

        repeatRows.push(
            <tr key={`funding-row-${i}`}>
                <td data-title="Date" className="fundingTableCell">
                    {tempDate}
                </td>
                {!notShowStartup &&
                    <td data-title="Startup" className="fundingTableCell red">
                        {tempCompany}
                    </td>
                }
                <td data-title="Amount" className="fundingTableCell">
                    {tempAmount}
                </td>
                {!notOwner &&
                    <td data-title="PostMoney" className="fundingTableCell">
                        {tempAmount}
                    </td>
                }
                <td data-title="Round" className="fundingTableCell">
                    {tempStage}
                </td>
                <td data-title="Investors" className="fundingTableCell nestedCell">
                    <div><span className="red">{tempInvestor}</span> / {tempAmount}</div>
                </td>
                {showVerified &&
                    <td data-title="Verified" className="fundingTableCell">
                        <div className="verified-status" data-verif={tempVerified}></div>
                    </td>
                }
            </tr>
        );
    }

    const testRows =
        <tbody className="paywall-box paywall-box-blurred">
            {repeatRows}
        </tbody>

    return (testRows);
}

// general reusable section
// startup relations, investors, etc.
export const renderLockedGeneralSection = (entityType, dataType, isPremiumLock, setState, sectionTitle) => {

    let repeatRows = [];
    let rowsToDisplay = 4;

    for (let i = 0; i < rowsToDisplay; i++) {

        const tempCompany = getRandom(testCompany);
        const tempIndustry = getRandom(testIndustries);

        const isHidden = (i > 2 ? "hidden-xs-down hidden-lg-up" : "")

        repeatRows.push(
            <div key={`locked-row-${i}`} className={`col-xl-4 col-md-6 col-sm-6 col-xs-12 ${isHidden}`}>
                <a><div className={`image image-locked-content ${dataType == "employees" ? `image-locked-team` : ""}`} /></a>
                <a style={{ pointerEvents: 'none', cursor: 'auto' }}>
                    <h3>{tempCompany}</h3>
                </a>
                <p>{tempIndustry}</p>
            </div>
        );
    }

    return (
        <div className="block team" style={{ padding: 0 }}>
            <div className="paywall-box no-border">
                <div className="paywall-content m-0">
                    {isPremiumLock ?
                        <a onClick={() => { amplitudeTrack(`Pricing - ${entityType} profile - ${dataType} section`); showContactForm(setState) }} >
                            <span className="paywall-label">
                                <div className="locked-inline-section">
                                    <div className="m-0">
                                        <div className="paywall-label-header">
                                            Preview of a locked feature
                                        </div>
                                        <div className="paywall-label-message">
                                            {`Upgrade to view all ${dataType} for this ${entityType}`}
                                        </div>
                                    </div>
                                    <span className="btn btn-main locked-inline-button">Upgrade</span>
                                </div>
                            </span>
                        </a>
                        :
                        <a onClick={() => { Login(); amplitudeTrack(`Login ${entityType} - ${dataType}`) }}>
                            <span className="paywall-label">
                                <div className="locked-inline-section">
                                    <div className="m-0">
                                        <div className="paywall-label-header">
                                            Preview of a locked feature
                                        </div>
                                        <div className="paywall-label-message">
                                            {`Login to learn more about this ${entityType}'s ${dataType}`}
                                        </div>
                                    </div>
                                    <span className="btn btn-main locked-inline-button">Login</span>
                                </div>
                            </span>
                        </a>
                    }
                </div>
                <div className="block team team-section m-0" style={{ paddingLeft: 30 }} >
                    <div className="title d-flex">
                        <h2>{sectionTitle}</h2>
                    </div>
                </div>
                <div style={{ padding: 30, paddingTop: 5, margin: 0 }} className="paywall-text-blur">
                    <div className="row">
                        {repeatRows}
                    </div>
                </div>
            </div>
        </div>
    )
}

// funding evolution - locked element
export const renderLockedFundingEvol = (entityType, setState, sectionRef = null) => {

    return (
        <>
            <div className="block team scrollmargin" style={{ padding: 0 }} id="section-funding" ref={sectionRef}>
                <div className="paywall-box no-border">
                    <div className="paywall-content mb-0">
                        <a onClick={() => { amplitudeTrack(`Pricing - ${entityType} profile - Funding evolution`); showContactForm(setState) }} >
                            <span className="paywall-label">
                                <div className="locked-inline-section">
                                    <div className="m-0">
                                        <div className="paywall-label-header">
                                            Preview of a locked feature
                                        </div>
                                        <div className="paywall-label-message">
                                            Upgrade to view this {entityType}'s funding history evolution. (Note: the chart below contains test data to demonstrate the feature)
                                        </div>
                                    </div>
                                    <span className="btn btn-main locked-inline-button" >Upgrade</span>
                                </div>
                            </span>
                        </a>
                    </div>
                    <div id="startup-funding-evolution" className="funding-chart profile-section-box" style={{ padding: 30, paddingTop: 0, paddingBottom: 20, margin: 0 }}>
                        <div className="funding-chart__content" >
                            <h2 className="funding-chart__heading mb-20 profile-section-heading">Funding Evolution</h2>
                            <div className='paywall-text-blur'>
                                <img src={`${PUBLIC_IMG_URL}/directory-locked-charts-img/startup-funding-evolution.png`} alt='Startup-Funding-Evolution' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

// Directory Chart - locked element
export const renderLockedDirectoryChart = (entityType, setState) => {
    return (
        <>
            <div className="paywall-box">
                <div className="paywall-content">
                    <a onClick={() => { amplitudeTrack(`Pricing - ${entityType} Directory - Chart Directory`); showContactForm(setState, true) }} >
                        <span className="paywall-label">
                            <div className="locked-inline-section">
                                <div className="m-0">
                                    <div className="paywall-label-header">
                                        Preview of a locked feature
                                    </div>
                                    <div className="paywall-label-message">
                                        Upgrade to view detailed charts based on your selected filters
                                    </div>
                                </div>
                                <span className="btn btn-main locked-inline-button" >Upgrade</span>
                            </div>
                        </span>
                    </a>
                </div>
            </div>

            <div id="network-map-cards" className="locked-network-map-main  network-map-main network-map-cards">
                <div className="map-dashboard-wrapper">
                    <div className="map-dashboard-graph">
                        <div className="graph__title">Yearly Breakdown of Investment Amount and Deals</div>
                        <div className="graph__chart">
                            <span className="paywall-label">
                                <a onClick={() => showContactForm(setState, true)}>{lockImg} </a>
                            </span>
                            <div className='paywall-text-blur'>
                                <img src={`${PUBLIC_IMG_URL}/directory-locked-charts-img/bar-chart-1.png`} alt='Locked-bar-chart-1' />

                            </div>
                        </div>
                    </div>

                    <div className="map-dashboard-graph">
                        <div className="graph__title">Yearly Breakdown of Startups Founded Against Startups Funded</div>
                        <div className="graph__chart">
                            <span className="paywall-label">
                                <a onClick={() => showContactForm(setState, true)}>{lockImg}</a>
                            </span>
                            <div className='paywall-text-blur'>
                                <img src={`${PUBLIC_IMG_URL}/directory-locked-charts-img/line-chart.png`} alt='Locked-line-chart' />

                            </div>
                        </div>
                    </div>
                    <div className="map-dashboard-graph">
                        <div className="graph__title">Funding - Share Per Primary Industry (2017 - Present)</div>
                        <div className="graph__chart">
                            <span className="paywall-label ">
                                <a onClick={() => showContactForm(setState, true)}>{lockImg}</a>
                            </span>
                            <div className='paywall-text-blur'>
                                <img src={`${PUBLIC_IMG_URL}/directory-locked-charts-img/donut-chart-1.png`} alt='Locked-donut-chart-1' />
                            </div>
                        </div>
                    </div>
                    <div className="map-dashboard-graph">
                        <div className="graph__title">Deals - Share Per Primary Industry (2017 - Present)</div>
                        <div className="graph__chart">
                            <span className="paywall-label">
                                <a onClick={() => showContactForm(setState, true)}>{lockImg}</a>
                            </span>
                            <div className='paywall-text-blur'>
                                <img src={`${PUBLIC_IMG_URL}/directory-locked-charts-img/donut-chart-2.png`} alt='Locked-donut-chart-2' />

                            </div>
                        </div>
                    </div>
                    <div className="map-dashboard-graph">
                        <div className="graph__title">Total Funding and Number of Deals by Industry (2017 - Present)</div>
                        <div className="graph__chart">
                            <span className="paywall-label">
                                <a onClick={() => showContactForm(setState, true)}>{lockImg}</a>
                            </span>
                            <div className='paywall-text-blur'>
                                <img src={`${PUBLIC_IMG_URL}/directory-locked-charts-img/bar-chart-2.png`} alt='Locked-bar-chart-2' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

// Directory Landscape - locked element
export const renderLockedStartupLandscape = (entityType, setState) => {
    return (
        <>
            <div className="paywall-box">
                <div className="paywall-content">
                    <a onClick={() => { amplitudeTrack(`Pricing - ${entityType} Directory - Landscape Directory`); showContactForm(setState, true) }} >
                        <span className="paywall-label">
                            <div className="locked-inline-section">
                                <div className="m-0">
                                    <div className="paywall-label-header">
                                        Preview of a locked feature
                                    </div>
                                    <div className="paywall-label-message">
                                        Upgrade to view a market landscape with the {entityType.toLowerCase()} distribution of your selected filters
                                    </div>
                                </div>
                                <span className="btn btn-main locked-inline-button" >Upgrade</span>
                            </div>
                        </span>
                    </a>
                </div>
            </div>

            <div className="locked-network-map-main network-map-main network-map-cards">
                <div className="network-map-groups pt-3 pb-3">
                    <span className={"group-buttons active"}>
                        Country
                    </span>
                    <span className={"group-buttons inactive"}>
                        Primary Industry
                    </span>
                    <span className={"group-buttons inactive"}>
                        Sub Industry
                    </span>
                    <span className={"group-buttons inactive"}>
                        Business Type
                    </span>
                </div>
                <div className="map-card-wrapper">
                    <span className="paywall-label">
                        <a onClick={() => showContactForm(setState, true)}>{lockImg}</a>
                    </span>
                    <div className='paywall-text-blur d-flex justify-content-center'>
                        <img className="paywall-landxcape-img" src={`${PUBLIC_IMG_URL}/directory-locked-charts-img/locked-img-landscape.png`} alt='Locked-bar-chart-1' />
                    </div>
                </div>
            </div>
        </>
    )
}

export const renderLockedStartupSection = (entityType, investorName, setState, sectionRef) => {
    const isStartup = entityType === "startup";
    let repeatRows = [];
    let rowsToDisplay = 4;
    let repeatColumns = [];

    for (let i = 0; i < rowsToDisplay; i++) {

        repeatRows.push(
            <React.Fragment key={`startup-row-${i}`}>
                <div className="card-content">
                    <a><div className={`image image-locked-content `} /></a>
                    <div className="card-pill">
                        <VerificationPillBadgeToolTip pillColor='green' pillText={tempIndustry} isBasicPill />
                    </div>
                    <a className="card-heading">
                        {tempCompany}
                    </a>
                    <p className="card-description">{tempDescription}</p>
                    <a className="card-link">
                        <i className="fa fa-link"></i>
                        {tempCompany}
                    </a>
                </div>
            </React.Fragment>
        );
        repeatColumns.push(
            <React.Fragment key={`startup-column-${i}`}>
                <div className="carousel-slide">
                    <a><div className={`image image-locked-content`} style={{ height: '160px', width: '160px', marginRight: " 0px !important" }} /></a>
                </div>
            </React.Fragment>
        );
    }

    return (
        <div className="block team scrollmargin" style={{ padding: 0 }} ref={sectionRef} id="section-startup-relations">
            <div className="paywall-box no-border" >
                <div className="paywall-content">
                    <a onClick={() => { amplitudeTrack(`Pricing - ${entityType} profile - Startup Section`); showContactForm(setState) }} >
                        <span className="paywall-label">
                            <div className="locked-inline-section">
                                <div className="m-0">
                                    <div className="paywall-label-header">
                                        Preview of a locked feature
                                    </div>
                                    <div className="paywall-label-message">
                                        {`Upgrade to view all ${entityType === "investor" ? "startups" : "investors"} for this ${entityType}`}
                                    </div>
                                </div>
                                <span className="btn btn-main locked-inline-button">Upgrade</span>
                            </div>
                        </span>
                    </a>
                </div>

                <div className="portfolio-list-section" style={{ padding: 30, paddingTop: 20, paddingBottom: 0, margin: 0, marginTop: 10 }}>
                    <h2 className="profile-section-heading">{isStartup ? "Investors" : "Startups"}</h2>
                </div>
                <div className="portfolio-list-section " style={{ padding: 30, paddingTop: 0, paddingBottom: 0, margin: 0 }}>
                    <div className='portfolio-card' style={{ margin: 0 }}>
                        <div className="card-container ">
                            <div className="card-header">
                                {!isStartup && <div>Portfolio</div>}
                                <div className='text-span'>
                                    <span className="portfolio-facts">
                                        <span className="investor-name">{investorName}</span> has
                                        <span className="portfolio-count paywall-text-blur">
                                            {" "}
                                            {100}
                                        </span>
                                        {isStartup ? " investors" : (
                                            <>
                                                {"startups in its portfolio"}
                                                <>
                                                    {", mostly in"}
                                                    <span className="popular-industry paywall-text-blur">{" "}{"Technology"}</span>
                                                </>
                                            </>
                                        )}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="portfolio-list-section  paywall-text-blur " style={{ padding: 30, paddingTop: 0, paddingBottom: 0, margin: 0 }}>
                    <div className='portfolio-card' style={{ margin: 0 }}>
                        <div className="card-container " style={{ margin: 0 }}>
                            <div className="card-details row" style={{ margin: 0 }}>
                                {repeatRows}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="portfolio-list-section" style={{ padding: 30, paddingTop: 0, paddingBottom: 0, margin: 0 }}>
                    <div className="relations-carousel" style={{ margin: 0 }}>
                        <div className="carousel-container" style={{ margin: 0 }}>
                            <div className="carousel-header" style={{ margin: 0 }}>
                                <div>{isStartup ? "Linked Institution" : "Relations"}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="portfolio-list-section  paywall-text-blur " style={{ padding: 30, paddingTop: 0, paddingBottom: 0, margin: 0 }}>
                    <div className="relations-carousel" style={{ margin: 0, marginBottom: 20 }}>
                        <div className="carousel-container" style={{ margin: 0 }}>
                            <div className="card-details" style={{ margin: 0 }}>
                                <div className="carousel row" id="carousel" style={{ margin: 0 }}>
                                    {repeatColumns}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    )

}

export const renderLockedTeamMemberSection = (entityType, setState, sectionref) => {
    return (
        <>
            <div className="block team scrollmargin" style={{ padding: 0 }} id="section-teams" ref={sectionref}>
                <div className="paywall-box no-border" style={{ padding: 0 }}>
                    <div className="paywall-content mb-0" style={{ padding: 0 }}>
                        <a onClick={() => { amplitudeTrack('Team Contact Details - Clicked to Pricing'); showContactForm(setState) }} >
                            <span className="paywall-label">
                                <div className="locked-inline-section">
                                    <div className="m-0">
                                        <div className="paywall-label-header">
                                            Preview of a locked feature
                                        </div>
                                        <div className="paywall-label-message">
                                            {`Upgrade to view all team members for this ${entityType}`}
                                        </div>
                                    </div>
                                    <span className="btn btn-main locked-inline-button">Upgrade</span>
                                </div>
                            </span>
                        </a>
                    </div>
                    <div className="team-members-section profile-section-box" style={{ padding: "0 30px 30px", margin: 0 }}>
                        <div className="section-heading">
                            <div>
                                <h2 className="profile-section-heading">Team Members</h2>
                                <span className="section-subtitle" style={{ margin: 0 }}>
                                    This profile has <span className="section-subtitle__count paywall-text-blur">{10}</span> team members
                                </span>
                            </div>
                        </div>
                        <LockedTeamMembersSection />
                    </div>
                </div>

            </div>
        </>

    )

}

export const renderLockedFundingTablesSection = (entityType, investorName, type, setState, options = {}) => {
    const tableType = {
        investmentsInStartups: "investmentsInStartups",
        investorInvestments: "investorInvestments",
        investmentsInFunds: "investmentsInFunds",
        managedFunds: "managedFunds",
        portfolioExits: "portfolioExits",
        startupInvestments: "startupInvestments",
        fundingRounds: "fundingRounds",
        startupAcquisitions: "startupAcquisitions"
    }
    const props = {
        totalFund: 200,
        isInvestorInvestments: tableType[type] === "investorInvestments",
        isStartupInvestment: tableType[type] === "investmentsInStartups",
        isFundInvestment: tableType[type] === "investmentsInFunds",
        isPortfolioExits: tableType[type] === "portfolioExits",
        isManagedFunds: tableType[type] === "managedFunds",
        fundingRounds: tableType[type] === "fundingRounds",
        isStartupInvTable: tableType[type] === "startupInvestments",
        isFundingRounds: tableType[type] === "fundingRounds",
        isStartupAcquisitions: tableType[type] === "startupAcquisitions",
        isInvestment: tableType[type] === "startupInvestments" || tableType[type] === "investmentsInStartups" || tableType[type] === "investmentsInFunds" || tableType[type] === "investorInvestments",
        name: investorName,
        entityType,
        numberFunding: options.numberFunding
    }
    const showValuation = (!props.isFundInvestment && !props.isManagedFunds && !props.isStartupInvTable);
    const hasTableIndent = (tableType[type] === 'investmentsInStartups' || tableType[type] === 'fundingRounds' || tableType[type] === 'startupInvestments' || tableType[type] === 'investorInvestments');

    const state = {
        numberOfFundedStartups: 200,
        numberOfFundingRounds: 200,
        totalInvestmentAmount: 200,
        totalRecords: options.numberFunding || 200
    }
    const usesStaticLockedPreview = props.isPortfolioExits || props.isInvestorInvestments || props.isFundInvestment || props.isFundingRounds;
    let { title, tableName } = getTableTitle(props, state);
    let tableRows = [];
    const roundOverview = [
        <tr key={`overview-row`} className="table-main-row">
            <td colSpan={showValuation ? 5 : 6}>
                <div className="overview-name-row">
                    {!props.isFundInvestment &&
                        <a><div className={`image image-locked-content `} /></a>
                    }
                    <div className="overview-detail">
                        {props.isFundInvestment || props.isStartupInvTable ?
                            <p>{"Kavz Star"}</p>
                            :
                            <p>{"Orange Corner Innovation Fund (OCIF)"}</p>
                        }
                        <p>{"United Arab Emirates (UAE)"}</p>
                    </div>
                </div>
            </td>

            {/* valuation */}
            <td colSpan={showValuation ? 4 : 3}>
                {(showValuation) &&
                    <div className="overview-detail">
                        <>
                            <p>
                                <span>
                                    {"$9.5M - $18.2M"}
                                    {' '}
                                    <span className="secondary-label" >
                                        <i className="fas fa-info-circle"></i>
                                    </span>
                                </span>
                            </p>
                            <p>{"Valuation Estimate"}</p>
                        </>
                    </div>
                }
            </td>

            <td colSpan={2}>
                <div className="overview-detail">
                    <p>{"$100K"}</p>
                    <p>Amount</p>
                </div>
            </td>
            <td colSpan={2}>
                <div className="overview-detail">
                    <p>{"Undisclosed"}</p>
                    <p>Round</p>
                </div>
            </td>
            <td colSpan={2} data-title="Verified">
                <div className="overview-detail">
                    <p>{"Verified"}</p>
                    <p>Status</p>
                </div>
            </td>
        </tr>
    ]
    const tableHeading = (
        <tr className="table-header-desktop">

            {hasTableIndent &&
                <th colSpan={2} className="table-indent"></th>
            }

            {(props.isFundInvestment) &&
                <th colSpan={4} data-title="Fund Manager">Fund Manager</th>
            }

            <th colSpan={(props.isManagedFunds ? 5 : 3)}>Investor(s)</th>
            <th colSpan={2}>Amount</th>

            {!props.isFundInvestment && (
                <th colSpan={2} data-title="Deal Term">
                    Deal Term
                    <span className="secondary-label"
                        role="button"
                        data-toggle="tooltip"
                        data-placement="right"
                        title={DEAL_TERM_MEANING}>
                        <i className="fas fa-question-circle"></i>
                    </span>
                </th>
            )}

            <th colSpan={2} data-title="Date">Date</th>
            <th colSpan={2}>
                Vehicle
                <span className="secondary-label" role="button" data-toggle="tooltip" data-placement="right" title={INVESTMENT_VEHICLE_MEANING}>
                    <i className="fas fa-question-circle"></i>
                </span>
            </th>
            <th colSpan={2}>Verified?</th>

        </tr>
    )
    const tableCell = (
        <div className="entity-row-box">
            <a><div className={`image image-locked-content image-locked-team `} /></a>
            <p>
                <>
                    <a>
                        {investorName}
                    </a>
                    <p>{"Germany"}</p>
                    <p>Lead Investor</p>
                </>
            </p>
        </div>)
    const tableData = [
        <tr data-first={(true)}>

            {hasTableIndent &&
                <td colSpan={2} className="table-indent"></td>
            }

            {(props.isFundInvestment) &&
                <td colSpan={4} className={`entity-row cell-first-investor cell-responsive`} rowSpan={1} data-mobile-title="Fund Manager">
                    {tableCell}
                </td>
            }

            <td colSpan={(props.isManagedFunds ? 5 : 3)} className="entity-row" data-mobile-title="Investor">
                {tableCell}
            </td>

            <td className='text-nowrap' colSpan={2} data-mobile-title="Amount">
                {"$100K"}
            </td>

            {!props.isFundInvestment &&
                <td colSpan={2} data-mobile-title="Deal Term">
                    {"Convertible Note"}
                </td>
            }

            <td className={"cell-first-investor cell-responsive"} rowSpan={1} colSpan={2} data-mobile-title="Date">
                {"Sep 2023"}
            </td>

            <td className={"cell-first-investor cell-responsive"} rowSpan={1} colSpan={2} data-mobile-title="Vehicle">
                {"Equity / $1M"}
            </td>

            <td className={"cell-first-investor cell-responsive"} rowSpan={1} colSpan={2} data-mobile-title="Verified?">
                {getVerificationIcon(1)}
            </td>

        </tr>
    ];

    tableRows.push(roundOverview, tableHeading, tableData);
    return (
        <>
            <div className="block team scrollmargin" style={{ padding: 0, marginBottom: usesStaticLockedPreview ? 24 : 0 }} id={`section-${tableType[type]?.toLowerCase()}`}>
                <div className="paywall-box no-border">
                    <div className="paywall-content mb-0" id={`section-${tableType[type]?.toLowerCase()}`}>
                        <a onClick={() => { amplitudeTrack('Team Contact Details - Clicked to Pricing'); showContactForm(setState) }}>
                            <span className="paywall-label">
                                <div className="locked-inline-section">
                                    <div className="m-0">
                                        <div className="paywall-label-header">
                                            Preview of a locked feature
                                        </div>
                                        <div className="paywall-label-message">
                                            {getLockedFundingMessage(entityType, type)}
                                        </div>
                                    </div>
                                    <span className="btn btn-main locked-inline-button">Upgrade</span>
                                </div>
                            </span>
                        </a>
                    </div>
                    <div className="funding-box" style={{ marginTop: "0px !important", marginBottom: "0px !important" }}>
                        <div className="profile-section-box fundingrounds" style={{ padding: 30, paddingTop: 5, margin: 0, paddingBottom: usesStaticLockedPreview ? 30 : 0 }}>
                            <div className="funding-title m-0">
                                <div className="title paywall-blur m-0">
                                    {title}
                                </div>
                            </div>
                            {props.isPortfolioExits && renderLockedPortfolioExitsSection()}
                            {props.isInvestorInvestments && renderLockedInvestorInvestmentsSection()}
                            {props.isFundInvestment && renderLockedFundsInvestedSection()}
                            {props.isFundingRounds && renderLockedFundingRoundsSection()}
                        </div>
                    </div>
                    {!usesStaticLockedPreview && <div className="funding-box paywall-text-blur" style={{ padding: 30, paddingTop: 0, margin: 0, marginTop: "0px !important" }}>
                        <div className="fundingrounds row" style={{ paddingTop: 0, margin: 0, paddingBottom: 0 }}>
                            <div id="no-more-tables" style={{ width: '100%' }} className="mt-0">
                                <table className="w-100 m-0" data-table-indent={hasTableIndent}>
                                    <tbody key={tableType[type]}>
                                        <>{tableRows}</>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>}
                </div>
            </div >
        </>
    )

}

export const renderLockedQuestionSection = (entityType, setState, sectionRef) => {

    const renderQuestion = () => {
        return mockQuestionsData.map((item, i) => {
            return (
                <div className="info-box-container" key={i}>
                    <div className="info-box-title" data-toggle="collapse" href={"#faq-" + i} aria-expanded={i == 0 ? "true" : "false"}>
                        {item.question}
                    </div>
                    <div className={i == 0 ? "info-box-body collapse show" : "info-box-body collapse hide"} id={"faq-" + i}>
                        <div className='answers'>{item.answer}</div>
                    </div>
                </div>
            )
        });
    }
    return (
        <>
            <div className="block team scrollmargin" style={{ padding: 0 }} ref={sectionRef} id="section-questions">
                <div className="paywall-box no-border">
                    <div className="paywall-content">
                        <a onClick={() => { amplitudeTrack(`Pricing - ${entityType} profile - Questions`); showContactForm(setState) }} >
                            <span className="paywall-label">
                                <div className="locked-inline-section">
                                    <div className="m-0">
                                        <div className="paywall-label-header">
                                            Preview of a locked feature
                                        </div>
                                        <div className="paywall-label-message">
                                            Upgrade to view all questions for this {entityType}
                                        </div>
                                    </div>
                                    <span className="btn btn-main locked-inline-button">Upgrade</span>
                                </div>
                            </span>
                        </a>
                    </div>
                    <div className="mid-width-info-box profile-section-box question-section" style={{ padding: 30, paddingTop: 25, margin: 0 }}>
                        <h2 className="profile-section-heading mb-20">About this Startup</h2>
                        <div className="mid-width-info-box">
                            {renderQuestion()}
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export const renderLockedBenchmarkingTool = (entityType, entityId, setState, startupName, sectionRef, user) => {
    return (
        <>
            <div className="block team startup-benchmarking scrollmargin  " id="section-benchmarking" ref={sectionRef} style={{ padding: 0 }}>
                <div className="paywall-box no-border">
                    <div className="paywall-content">
                        <a onClick={() => { amplitudeTrack(`Pricing - ${entityType} profile - Benchmarking Tool`); showContactForm(setState) }} >
                            <span className="paywall-label">
                                <div className="locked-inline-section">
                                    <div className="m-0">
                                        <div className="paywall-label-header">
                                            Preview of a locked feature
                                        </div>
                                        <div className="paywall-label-message">
                                            Upgrade to view the benchmarking tool
                                        </div>
                                    </div>
                                    <span className="btn btn-main locked-inline-button">Upgrade</span>
                                </div>
                            </span>
                        </a>
                    </div>
                    <div className='lock-section-curtain'>
                        <DynamicStartupBenchmarking
                            data={mockBenchmarkingData}
                            id={entityId}
                            user={user}
                            startupName={startupName}
                            sectionref={sectionRef}
                        />
                    </div>
                </div>
            </div>
        </>
    )

}

// Home Dashboard Section - locked elements
export const renderLockedSavedDashboard = (section, setState) => {
    return (
        <>
            <div className="block" style={{ margin: 0 }} >
                <div className="paywall-box no-border" >
                    <div className="paywall-content">
                        <a onClick={() => { amplitudeTrack(`Pricing - Home Dashboard Section - Saved Views`); showContactForm(setState) }} href='/pricing' >
                            <span className="paywall-label">
                                <div className="locked-inline-section">
                                    <div className="m-0">
                                        <div className="paywall-label-header">
                                            Locked Feature
                                        </div>
                                        <div className="paywall-label-message">
                                            {section == 'view' ?
                                                HOME_DASHBOARD_SECTION_MESSAGES.view
                                                :
                                                HOME_DASHBOARD_SECTION_MESSAGES.map
                                            }
                                        </div>
                                    </div>
                                    <span className="btn btn-main locked-inline-button">Upgrade</span>
                                </div>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}

export const renderLockedEntityName = (entityType, index) => {
    return entityType == 'STARTUP' ? testCompany[index] : testInvestor[index];
}

// funding rounds directory - test data
export const testDataFundingRounds = [
    {
        "id": 1,
        "investedin_id": 1,
        "investedin_data": {
            "id": 1,
            "code": "test-company-1",
            "logo": mainLogo,
            "name": testCompany[0],
            "type": "STARTUP"
        },
        "currency": null,
        "location_data": {
            "id": 1,
            "name": "United Arab Emirates (UAE)"
        },
        "industry_data": [
            {
                "id": 1,
                "name": testIndustries[0]
            },
            {
                "id": 2,
                "name": testIndustries[1]
            },
            {
                "id": 3,
                "name": testIndustries[2]
            },
            {
                "id": 4,
                "name": testIndustries[3]
            }
        ],
        "funding_stage_data": {
            "id": 1,
            "name": "HBS"
        },
        "date_raised": "2028-11-01T00:00:00.000Z",
        "amount": 898989,
        "total_amount_raised": 547898989,
        "investors_data": [
            {
                "name": testInvestor[0],
                "id": 1,
                "logo": mainLogo,
                "type": "INVESTOR"
            },
            {
                "name": testInvestor[1],
                "id": 2,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ],
        investment_vehicle_data: {
            "id": 1,
            "name": "HBS"
        }
    },
    {
        "id": 2,
        "investedin_id": 2,
        "investedin_data": {
            "id": 2,
            "code": "test-company-2",
            "logo": mainLogo,
            "name": testCompany[1],
            "type": "STARTUP"
        },
        "currency": null,
        "location_data": {
            "id": 2,
            "name": "Sweden"
        },
        "industry_data": [
            {
                "id": 2,
                "name": testIndustries[1]
            },
            {
                "id": 3,
                "name": testIndustries[2]
            }
        ],
        "funding_stage_data": {
            "id": 1,
            "name": "HBS"
        },
        "date_raised": "2027-11-01T00:00:00.000Z",
        "amount": 800000,
        "total_amount_raised": 57898989,
        "investors_data": [
            {
                "name": testInvestor[1],
                "id": 2,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ],
        investment_vehicle_data: {
            "id": 5,
            "name": "Series A"
        }
    },
    {
        "id": 3,
        "investedin_id": 3,
        "investedin_data": {
            "id": 3,
            "code": "test-company-3",
            "logo": mainLogo,
            "name": testCompany[2],
            "type": "STARTUP"
        },
        "currency": null,
        "location_data": {
            "id": 3,
            "name": "Egypt"
        },
        "industry_data": [
            {
                "id": 3,
                "name": testIndustries[2]
            }
        ],
        "funding_stage_data": {
            "id": 2,
            "name": "IPO"
        },
        "date_raised": "2021-09-29T20:00:00.000Z",
        "amount": null,
        "total_amount_raised": 9898459,
        "investors_data": [
            {
                "name": testInvestor[2],
                "id": 2,
                "logo": mainLogo,
                "type": "INVESTOR"
            },
            {
                "name": testInvestor[3],
                "id": 3,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ],
        investment_vehicle_data: {
            "id": 2,
            "name": "IPO"
        }
    },
    {
        "id": 4,
        "investedin_id": 4,
        "investedin_data": {
            "id": 4,
            "code": "test-company-4",
            "logo": mainLogo,
            "name": testCompany[3],
            "type": "STARTUP"
        },
        "currency": null,
        "location_data": {
            "id": 4,
            "name": "Lebanon"
        },
        "industry_data": [
            {
                "id": 4,
                "name": testIndustries[3]
            }
        ],
        "funding_stage_data": {
            "id": 3,
            "name": "Series F"
        },
        "date_raised": "2021-09-27T20:00:00.000Z",
        "amount": 50000000,
        "total_amount_raised": 54788989,
        "investors_data": [
            {
                "name": testInvestor[3],
                "id": 3,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ],
        investment_vehicle_data: {
            "id": 3,
            "name": "Series F"
        }
    },
    {
        "id": 5,
        "investedin_id": 5,
        "investedin_data": {
            "id": 5,
            "code": "test-company-5",
            "logo": null,
            "name": testInvestor[4],
            "type": "STARTUP"
        },
        "currency": null,
        "location_data": {
            "id": 5,
            "name": "Saudi Arabia (KSA)"
        },
        "industry_data": [
            {
                "id": 5,
                "name": testIndustries[4]
            }
        ],
        "funding_stage_data": {
            "id": 4,
            "name": "SEED"
        },
        "date_raised": "2021-09-26T20:00:00.000Z",
        "amount": 2000000,
        "total_amount_raised": 65898989,
        "investors_data": [
            {
                "name": testInvestor[4],
                "id": 4,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ],
        investment_vehicle_data: {
            "id": 4,
            "name": "SEED"
        }
    },
]

export const testDataExits = [
    {
        "id": 1,
        "investedin_data": {
            "id": 1,
            "code": "round-please",
            "logo": mainLogo,
            "name": testInvestor[0],
            "type": "STARTUP"
        },
        "industry_data": null,
        "investedin_hq": {
            "id": 1,
            "name": "Germany"
        },
        "date_raised": "2021-09-04T20:00:00.000Z",
        "amount_raised": 20000000,
        "investors": [],
        "primary_industry_data": [
            {
                "id": 1,
                "name": testIndustries[0]
            },
        ],
        "location_data": {
            "id": 1,
            "name": "United Arab Emirates (UAE)"
        },
        "time_to_exit": 11,
        "investors_data": [
            {
                "name": testInvestor[0],
                "id": 1,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ],
    },
    {
        "id": 2,
        "investedin_data": {
            "id": 2,
            "code": "semi-business-startup",
            "logo": mainLogo,
            "name": testInvestor[1],
            "type": "STARTUP"
        },
        "industry_data": [
            {
                "id": 1,
                "name": testIndustries[0]
            },
            {
                "id": 2,
                "name": testIndustries[1]
            }
        ],
        "investedin_hq": {
            "id": 2,
            "name": "United Arab Emirates (UAE)"
        },
        "date_raised": "2021-08-29T20:00:00.000Z",
        "amount_raised": 100000000,
        "investors": [],
        "primary_industry_data": [
            {
                "id": 3,
                "name": testIndustries[2]
            }
        ],
        "location_data": {
            "id": 2,
            "name": "Australia"
        },
        "time_to_exit": 5,
        "investors_data": [
            {
                "name": testInvestor[1],
                "id": 2,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ]
    },
    {
        "id": 3,
        "investedin_data": {
            "id": 3,
            "code": "global-digital-address",
            "logo": mainLogo,
            "name": testInvestor[2],
            "type": "STARTUP"
        },
        "industry_data": [
            {
                "id": 4,
                "name": testIndustries[3]
            },
            {
                "id": 5,
                "name": testIndustries[4]
            }
        ],
        "investedin_hq": {
            "id": 3,
            "name": "Egypt"
        },
        "date_raised": "2021-08-28T20:00:00.000Z",
        "amount_raised": 1111,
        "investors": [],
        "primary_industry_data": [
            {
                "id": 1,
                "name": testIndustries[0]
            }
        ],
        "location_data": {
            "id": 3,
            "name": "New Zealand"
        },
        "time_to_exit": 7,
        "investors_data": [
            {
                "name": testInvestor[2],
                "id": 3,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ],
    },
    {
        "id": 4,
        "investedin_data": {
            "id": 4,
            "code": "round-please",
            "logo": mainLogo,
            "name": testInvestor[3],
            "type": "STARTUP"
        },
        "industry_data": null,
        "investedin_hq": {
            "id": 4,
            "name": "Germany"
        },
        "date_raised": "2021-09-04T20:00:00.000Z",
        "amount_raised": 20000000,
        "investors": [],
        "primary_industry_data": [
            {
                "id": 2,
                "name": testIndustries[1]
            }
        ],
        "location_data": {
            "id": 5,
            "name": "Japan"
        },
        "time_to_exit": 4,
        "investors_data": [
            {
                "name": testInvestor[3],
                "id": 4,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ],
    },
    {
        "id": 5,
        "investedin_data": {
            "id": 5,
            "code": "semi-business-startup",
            "logo": mainLogo,
            "name": testInvestor[4],
            "type": "STARTUP"
        },
        "industry_data": [
            {
                "id": 3,
                "name": testIndustries[2]
            },
            {
                "id": 4,
                "name": testIndustries[3]
            }
        ],
        "investedin_hq": {
            "id": 5,
            "name": "United Arab Emirates (UAE)"
        },
        "date_raised": "2021-08-29T20:00:00.000Z",
        "amount_raised": 100000000,
        "investors": [],
        "primary_industry_data": [
            {
                "id": 5,
                "name": testIndustries[4]
            }
        ],
        "location_data": {
            "id": 6,
            "name": "Singapore"
        },
        "time_to_exit": 2,
        "investors_data": [
            {
                "name": testInvestor[4],
                "id": 6,
                "logo": null,
                "type": "INVESTOR"
            }
        ],
    },
]

export const testDataCompanyTransactions = [
    {
        "id": 1,
        "investedin_id": 1,
        "investedin_data": {
            "id": 1,
            "code": "test-company-1",
            "logo": mainLogo,
            "name": testCompany[0],
            "type": "STARTUP"
        },
        "currency": null,
        "location_data": {
            "id": 1,
            "name": "United Arab Emirates (UAE)"
        },
        "industry_data": [
            {
                "id": 1,
                "name": testIndustries[0]
            }
        ],
        "funding_stage_data": {
            "id": 1,
            "name": "Series A"
        },
        "date_raised": "2028-11-01T00:00:00.000Z",
        "amount": 898989,
        "total_amount_raised": 547898989,
        "investors_data": [
            {
                "name": testInvestor[0],
                "id": 1,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ],
        investment_vehicle_data: {
            "id": 1,
            "name": "Equity"
        }
    },
    {
        "id": 2,
        "investedin_id": 2,
        "investedin_data": {
            "id": 2,
            "code": "test-corporate-1",
            "logo": mainLogo,
            "name": testInvestor[5],
            "type": "CORPORATE"
        },
        "currency": null,
        "location_data": {
            "id": 2,
            "name": "Saudi Arabia (KSA)"
        },
        "industry_data": [
            {
                "id": 2,
                "name": testIndustries[1]
            }
        ],
        "funding_stage_data": {
            "id": 2,
            "name": "PE Growth"
        },
        "date_raised": "2027-11-01T00:00:00.000Z",
        "amount": 25000000,
        "total_amount_raised": 57898989,
        "investors_data": [
            {
                "name": testInvestor[1],
                "id": 2,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ],
        investment_vehicle_data: {
            "id": 2,
            "name": "PE Growth"
        }
    },
    {
        "id": 3,
        "investedin_id": 3,
        "investedin_data": {
            "id": 3,
            "code": "test-company-2",
            "logo": mainLogo,
            "name": testCompany[1],
            "type": "STARTUP"
        },
        "currency": null,
        "location_data": {
            "id": 3,
            "name": "Egypt"
        },
        "industry_data": [
            {
                "id": 3,
                "name": testIndustries[2]
            }
        ],
        "funding_stage_data": {
            "id": 3,
            "name": "SEED"
        },
        "date_raised": "2021-09-29T20:00:00.000Z",
        "amount": 2000000,
        "total_amount_raised": 9898459,
        "investors_data": [
            {
                "name": testInvestor[2],
                "id": 3,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ],
        investment_vehicle_data: {
            "id": 3,
            "name": "SEED"
        }
    },
    {
        "id": 4,
        "investedin_id": 4,
        "investedin_data": {
            "id": 4,
            "code": "test-corporate-2",
            "logo": mainLogo,
            "name": testInvestor[6],
            "type": "CORPORATE"
        },
        "currency": null,
        "location_data": {
            "id": 4,
            "name": "Lebanon"
        },
        "industry_data": [
            {
                "id": 4,
                "name": testIndustries[3]
            }
        ],
        "funding_stage_data": {
            "id": 4,
            "name": "Series F"
        },
        "date_raised": "2021-09-27T20:00:00.000Z",
        "amount": 50000000,
        "total_amount_raised": 54788989,
        "investors_data": [
            {
                "name": testInvestor[3],
                "id": 4,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ],
        investment_vehicle_data: {
            "id": 4,
            "name": "Series F"
        }
    },
    {
        "id": 5,
        "investedin_id": 5,
        "investedin_data": {
            "id": 5,
            "code": "test-company-3",
            "logo": null,
            "name": testCompany[2],
            "type": "STARTUP"
        },
        "currency": null,
        "location_data": {
            "id": 5,
            "name": "Sweden"
        },
        "industry_data": [
            {
                "id": 5,
                "name": testIndustries[4]
            }
        ],
        "funding_stage_data": {
            "id": 5,
            "name": "HBS"
        },
        "date_raised": "2021-09-26T20:00:00.000Z",
        "amount": 800000,
        "total_amount_raised": 65898989,
        "investors_data": [
            {
                "name": testInvestor[4],
                "id": 5,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ],
        investment_vehicle_data: {
            "id": 5,
            "name": "HBS"
        }
    },
]

export const testDataCompanyExits = [
    {
        "id": 1,
        "investedin_data": {
            "id": 1,
            "code": "test-company-exit-1",
            "logo": mainLogo,
            "name": testCompany[3],
            "type": "STARTUP"
        },
        "industry_data": null,
        "investedin_hq": {
            "id": 1,
            "name": "Germany"
        },
        "date_raised": "2021-09-04T20:00:00.000Z",
        "amount_raised": 20000000,
        "investors": [],
        "primary_industry_data": [
            {
                "id": 1,
                "name": testIndustries[0]
            },
        ],
        "location_data": {
            "id": 1,
            "name": "United Arab Emirates (UAE)"
        },
        "time_to_exit": 11,
        "investors_data": [
            {
                "name": testInvestor[0],
                "id": 1,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ],
    },
    {
        "id": 2,
        "investedin_data": {
            "id": 2,
            "code": "test-corporate-exit-1",
            "logo": mainLogo,
            "name": testInvestor[5],
            "type": "CORPORATE"
        },
        "industry_data": [
            {
                "id": 1,
                "name": testIndustries[0]
            },
            {
                "id": 2,
                "name": testIndustries[1]
            }
        ],
        "investedin_hq": {
            "id": 2,
            "name": "United Arab Emirates (UAE)"
        },
        "date_raised": "2021-08-29T20:00:00.000Z",
        "amount_raised": 100000000,
        "investors": [],
        "primary_industry_data": [
            {
                "id": 3,
                "name": testIndustries[2]
            }
        ],
        "location_data": {
            "id": 2,
            "name": "Australia"
        },
        "time_to_exit": 5,
        "investors_data": [
            {
                "name": testInvestor[1],
                "id": 2,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ]
    },
    {
        "id": 3,
        "investedin_data": {
            "id": 3,
            "code": "test-company-exit-2",
            "logo": mainLogo,
            "name": testCompany[4],
            "type": "STARTUP"
        },
        "industry_data": [
            {
                "id": 4,
                "name": testIndustries[3]
            },
            {
                "id": 5,
                "name": testIndustries[4]
            }
        ],
        "investedin_hq": {
            "id": 3,
            "name": "Egypt"
        },
        "date_raised": "2021-08-28T20:00:00.000Z",
        "amount_raised": 1111,
        "investors": [],
        "primary_industry_data": [
            {
                "id": 1,
                "name": testIndustries[0]
            }
        ],
        "location_data": {
            "id": 3,
            "name": "New Zealand"
        },
        "time_to_exit": 7,
        "investors_data": [
            {
                "name": testInvestor[2],
                "id": 3,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ],
    },
    {
        "id": 4,
        "investedin_data": {
            "id": 4,
            "code": "test-corporate-exit-2",
            "logo": mainLogo,
            "name": testInvestor[6],
            "type": "CORPORATE"
        },
        "industry_data": null,
        "investedin_hq": {
            "id": 4,
            "name": "Germany"
        },
        "date_raised": "2021-09-04T20:00:00.000Z",
        "amount_raised": 20000000,
        "investors": [],
        "primary_industry_data": [
            {
                "id": 2,
                "name": testIndustries[1]
            }
        ],
        "location_data": {
            "id": 5,
            "name": "Japan"
        },
        "time_to_exit": 4,
        "investors_data": [
            {
                "name": testInvestor[3],
                "id": 4,
                "logo": mainLogo,
                "type": "INVESTOR"
            }
        ],
    },
    {
        "id": 5,
        "investedin_data": {
            "id": 5,
            "code": "test-company-exit-3",
            "logo": mainLogo,
            "name": testCompany[5],
            "type": "STARTUP"
        },
        "industry_data": [
            {
                "id": 3,
                "name": testIndustries[2]
            },
            {
                "id": 4,
                "name": testIndustries[3]
            }
        ],
        "investedin_hq": {
            "id": 5,
            "name": "United Arab Emirates (UAE)"
        },
        "date_raised": "2021-08-29T20:00:00.000Z",
        "amount_raised": 100000000,
        "investors": [],
        "primary_industry_data": [
            {
                "id": 5,
                "name": testIndustries[4]
            }
        ],
        "location_data": {
            "id": 6,
            "name": "Singapore"
        },
        "time_to_exit": 2,
        "investors_data": [
            {
                "name": testInvestor[4],
                "id": 6,
                "logo": null,
                "type": "INVESTOR"
            }
        ],
    },
]

export const testDataLPTracker = [
    {
        "name": testInvestor[0],
        "id": 1,
        "investedin_id": 1,
        "investedin_data": {
            "id": 1,
            "code": "test-fund-1",
            "logo": mainLogo,
            "name": testInvestor[0],
            "type": "ENABLER"
        },
        "currency": "USD",
        "date_raised": "2021-08-03T20:00:00.000Z",
        "amount_raised": 150000,
        "industry_data": [
            {
                "id": 1,
                "name": testIndustries[0]
            },
            {
                "id": 2,
                "name": testIndustries[1]
            }
        ],
        "geo_focus_data": [
            {
                "id": 1,
                "name": "Australia"
            },
            {
                "id": 2,
                "name": "New Zealand"
            }
        ],
        "investors": []
    },
    {
        "name": testInvestor[1],
        "id": 2,
        "investedin_id": 2,
        "investedin_data": {
            "id": 2,
            "code": "test-funds-2",
            "logo": mainLogo,
            "name": testInvestor[1],
            "type": "INVESTOR"
        },
        "currency": "USD",
        "date_raised": "2021-08-02T20:00:00.000Z",
        "amount_raised": 20000000,
        "industry_data": [
            {
                "id": 3,
                "name": testIndustries[2]
            }
        ],
        "geo_focus_data": null,
        "investors": []
    },
    {
        "name": testInvestor[2],
        "id": 3,
        "investedin_id": 3,
        "investedin_data": {
            "id": 3,
            "code": "test-funds-3",
            "logo": mainLogo,
            "name": testInvestor[2],
            "type": "INVESTOR"
        },
        "currency": null,
        "date_raised": "2021-08-02T20:00:00.000Z",
        "amount_raised": 2000000,
        "industry_data": [
            {
                "id": 3,
                "name": testIndustries[2]
            }
        ],
        "geo_focus_data": null,
        "investors": []
    },
    {
        "name": testInvestor[3],
        "id": 4,
        "investedin_id": 4,
        "investedin_data": {
            "id": 4,
            "code": "test-funds-4",
            "logo": mainLogo,
            "name": testInvestor[3],
            "type": "INVESTOR"
        },
        "currency": "USD",
        "date_raised": "2021-08-01T20:00:00.000Z",
        "amount_raised": 50000000,
        "industry_data": [
            {
                "id": 4,
                "name": testIndustries[3]
            }
        ],
        "geo_focus_data": [
            {
                "id": 4,
                "name": "United Arab Emirates (UAE)"
            }
        ],
        "investors": []
    },
    {
        "name": testInvestor[4],
        "id": 5,
        "investedin_id": 5,
        "investedin_data": {
            "id": 5,
            "code": "test-funds-5",
            "logo": mainLogo,
            "name": testInvestor[4],
            "type": "INVESTOR"
        },
        "currency": "USD",
        "date_raised": "2021-08-01T20:00:00.000Z",
        "amount_raised": 200000000,
        "industry_data": [
            {
                "id": 5,
                "name": testIndustries[4]
            }
        ],
        "geo_focus_data": [
            {
                "id": 5,
                "name": "United Arab Emirates (UAE)"
            }
        ],
        "investors": []
    },
]

const mockQuestionsData = [
    {

        question: "What problem are you solving, or what value are you creating?",
        answer: nl2br(`Startups got you feeling like a lost tourist in a funhouse? MOCKSDT is your GPS, fortune cookie,
		and tequila shot all rolled into one. We untangle startup spaghetti and turn head-scratchers into high-fives.
		Funding? We got that. Good ideas? We practically sell those by the pound (organic, fair-trade ideas, of course)
		. Don't just dream of launching, let's launch this thing together... to the moon! (BYOB - Bring Your Own Bravery)`)
    },
    {
        question: "What's your market opportunity and how will you acquire customers?",
        answer: nl2br(`
		Our market opportunity is a candy store explosion! Marketing so fresh it'd out-sell ice to Eskimos. We'll stop the
		scroll faster than a cat video, leaving competitors choking on meteor showers of customers. Captivating content,
		irresistible promos, and service that makes Hallmark look cynical? We're launching straight into the sun of success.`),

    },
    {
        question: "Who are your competitors and what makes you different?",
        answer: nl2br(`Our competitors? More like flickering lightbulbs compared to our disco ball. We'll leave them trailing
		in a dazzling blur of innovation, customer obsession, and the ability to turn problems into profits. We're not just
		different, we're a supernova of awesome.`)

    },
    {
        question: "How will you monetize?",
        answer: nl2br(`Monetization? We got that on lock. Like, Midas touch on lock.
		Our revenue streams are a gushing geyser of gold, fueled by subscriptions that unlock a treasure trove of premium content.
		Think exclusive access, not locked doors. We turn dreams into dollars faster than a magician pulls a rabbit out of a hat
		(spoiler alert: it's a marketing budget).
		Basically, we're the kings (and queens) of turning clicks into cash`)
    },
    {
        question: "What are your top three challenges?",
        answer: nl2br(`1. Galactic Warp Drive Implementation: Assembling a team of interstellar engineers for teleportation technology
        2. Quantum Algorithm Discovery: Unraveling the secrets of quantum computing for interdimensional data analysis.
        3. Telepathic Branding: Harnessing psychic energies for mind-to-mind marketing strategies.`),

    }
];

const mockBenchmarkingData = [
    ...generateArrayOfObjects(
        {
            "id": getRandom(testNumber),
            "name": getRandom(testCompany),
            "code": getRandom(testNameCode),
            "logo": mainLogo,
            "location": getRandom(testLocation),
            "date_founded": getRandom(mockDate),
            "website": getRandom(testWebsite),
            "primary_industry": getRandom(testCompany),
            "min_num_emp": 10000,
            "max_num_emp": 0,
            "ranked": 0,
            "latest_funding": {
                "fb_id": getRandom(testNumber),
                "fr_id": getRandom(testNumber),
                "stage": getRandom(testCompany),
                "amount": 100000,
                "valuation": {
                    "max": 0,
                    "min": 0,
                    "is_estimate": 1
                },
                "date_raised": getRandom(mockDate)
            },
            "exit_data": [
                ...generateArrayOfObjects(
                    {
                        "entity_id": getRandom(testNumber),
                        "entity_type": getRandom(testCompany),
                        "name": getRandom(testCompany),
                        "logo": mainLogo,
                        "code": getRandom(testNameCode),
                    }, 2)
            ],
            "team_data": [
                ...generateArrayOfObjects(
                    {
                        "code": getRandom(testNameCode),
                        "logo": mainLogo,
                        "f_name": getRandom(testPeople),
                        "l_name": getRandom(testPeople),
                        "logo_date": getRandom(mockDate),
                        "people_id": getRandom(testNumber),
                        "logo_update": getRandom(mockDate)
                    })
            ],
            "founder_data": [
                ...generateArrayOfObjects(
                    {
                        "code": getRandom(testNameCode),
                        "role_id": getRandom(testNumber),
                        "last_name": getRandom(testPeople),
                        "people_id": getRandom(testNumber),
                        "role_name": getRandom(testCompany),
                        "first_name": getRandom(testPeople),
                        "profile_pic": mainLogo,
                        "profile_pic_date": getRandom(mockDate),
                        "profile_pic_update_date": getRandom(mockDate)
                    })
            ],
            "investors_data": [
                ...generateArrayOfObjects(
                    {
                        "code": getRandom(testNameCode),
                        "name": getRandom(testInvestor),
                        "entity_id": getRandom(testNumber),
                        "logo_date": getRandom(mockDate),
                        "logo_path": mainLogo,
                        "entity_type": getRandom(testCompany),
                        "logo_update_date": getRandom(mockDate),
                        "type": getRandom(testCompany),
                        "id": getRandom(testNumber)
                    })
            ]
        })
];
